import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Link, Card, Grid, Avatar, CardContent, Popover, MenuItem, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { validateBlog } from '../../../validation/Blog';
// import { deleteBlog, getSingleBlog } from 'src/redux/actions/Blogaction';
// utils
import { deleteBlog, getSingleBlog, updateBlog } from '../../../redux/actions/Blogaction';
//
import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify';
import EditBlogmodel from '../../../components/models/blog/EditBlogmodel';
import DeleteBlogmodel from '../../../components/models/blog/DeleteBlogmodel';

// ----------------------------------------------------------------------

const StyledCardMedia = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)',
});

const StyledTitle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2),
}));

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function BlogPostCard({ post, index }) {
  const { title, id } = post;
  const latestPostLarge = index === 0;
  const latestPost = index === 1 || index === 2;
  const [singleId, setSingleId] = useState('');
  const [open, setOpen] = useState(null);
  const [Deletemodel, setDeleteModel] = useState(null);
  const [Editmodel, setEditModel] = useState(null);
  const [Editblog, setEditblog] = useState(null);
  const [fielderror, setFieldError] = useState({});
  const [issubmit, setIssubmit] = useState(false);

  const dispatch = useDispatch();

  // Delete model
  const handeldeleteopen = () => setDeleteModel(true);
  const handeldeleteclose = () => setDeleteModel(false);

  // Edit model
  const handleEditOpen = () => setEditModel(true);
  const handleEditClose = () => {
    setOpen(false);
    setEditModel(false);
  };

  // for popover

  const handleOpenMenu = (event, id) => {
    setSingleId(id);
    setOpen(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };

  // delete popover button

  const handeldelete = () => {
    dispatch(deleteBlog(singleId));
    setDeleteModel(false);
    setOpen(false);
  };

  //  Edit popover button

  const handelEdit = () => {
    dispatch(getSingleBlog(singleId));
  };

  const singleBlog = useSelector((state) => state.Blog.singleblog);
  useEffect(() => {
    setEditblog(singleBlog);
  }, [singleBlog]);

  // handel change field
  const handleChange = (e) => {
    const keyName = e.target.name;
    const keyValue = e.target.value;
    setEditblog((prevState) => ({
      ...prevState,
      [keyName]: keyValue,
    }));
    if (issubmit) {
      setFieldError(validateBlog({ ...Editblog, keyName: Editblog }));
    }
  };

  // handel edit
  const handleeditok = () => {
    const obj = {
      title: Editblog?.title,
      url: Editblog?.url,
    };
    setIssubmit(true);
    setEditModel(false);
    setOpen(false);
    const error = validateBlog(Editblog);
    if (singleId !== undefined && Object.keys(error).length === 0) {
      dispatch(updateBlog(singleId, obj));
      // setEditModel(false);
    } else {
      console.log('Error:', error);
    }
    setFieldError(validateBlog(Editblog));
    // setOpen(false);
  };

  return (
    <Grid item xs={12} sm={latestPostLarge ? 12 : 6} md={latestPostLarge ? 6 : 3}>
      <Card sx={{ position: 'relative' }}>
        <StyledCardMedia
          sx={{
            ...((latestPostLarge || latestPost) && {
              pt: 'calc(100% * 4 / 3)',
              '&:after': {
                top: 0,
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
              },
            }),
            ...(latestPostLarge && {
              pt: {
                xs: 'calc(100% * 4 / 3)',
                sm: 'calc(100% * 3 / 4.66)',
              },
            }),
          }}
        >
          <SvgColor
            color="paper"
            src="/assets/icons/shape-avatar.svg"
            sx={{
              width: 80,
              height: 36,
              zIndex: 9,
              bottom: -15,
              position: 'absolute',
              color: 'background.paper',
              ...((latestPostLarge || latestPost) && { display: 'none' }),
            }}
          />
          <StyledAvatar
            // alt={author.name}
            // src={author.avatarUrl}
            sx={{
              ...((latestPostLarge || latestPost) && {
                zIndex: 9,
                top: 24,
                left: 24,
                width: 40,
                height: 40,
              }),
            }}
          />

          {/* <StyledCover alt={title} src={cover} /> */}
        </StyledCardMedia>

        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <StyledTitle
            color="inherit"
            variant="subtitle2"
            underline="hover"
            sx={{
              ...(latestPostLarge && { typography: 'h5', height: 60 }),
              ...((latestPostLarge || latestPost) && {
                color: 'common.black',
              }),
            }}
          >
            {title}
          </StyledTitle>
          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, id)}>
            <Iconify icon={'eva:more-vertical-fill'} />
          </IconButton>

          <Popover
            onClick={handelEdit}
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem onClick={handleEditOpen}>
              <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
              Edit
            </MenuItem>

            <MenuItem onClick={handeldeleteopen} sx={{ color: 'error.main' }}>
              <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
              Delete
            </MenuItem>

            {/* edit model */}

            <EditBlogmodel
              Editmodel={Editmodel}
              Editblog={Editblog}
              fielderror={fielderror}
              handleeditok={handleeditok}
              handleEditClose={handleEditClose}
              handleChange={handleChange}
              handeldeleteclose={handeldeleteclose}
            />

            {/* delete model */}

            <DeleteBlogmodel
              Deletemodel={Deletemodel}
              handeldeleteclose={handeldeleteclose}
              handeldelete={handeldelete}
            />
          </Popover>

          {/* <StyledInfo>
            {POST_INFO.map((info, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: index === 0 ? 0 : 1.5,
                  ...((latestPostLarge || latestPost) && {
                    color: "grey.500",
                  }),
                }}
              >
                <Iconify
                  icon={info.icon}
                  sx={{ width: 16, height: 16, mr: 0.5 }}
                />
                <Typography variant="caption">
                  {fShortenNumber(info.number)}
                </Typography>
              </Box>
            ))}
          </StyledInfo> */}
        </CardContent>
      </Card>
    </Grid>
  );
}
